import React__default from 'react';
import PropTypes from 'prop-types';
import { a as FormattedNumber } from './index-f48c5efa.js';
import Label from './Label.js';
import Title from './Title.js';
import { n as nodeOrStringProp } from './PropTypes-e1e509ba.js';
import './_rollupPluginBabelHelpers-e71b1aad.js';
import './tslib.es6-2748fcb6.js';
import './useIntl-2a91ee7b.js';
import './injectIntl-d3879c1a.js';
import './hoist-non-react-statics.cjs-50d12f04.js';
import './index-f5c6df27.js';
import './_commonjsHelpers-17042db9.js';
import './provider-936ecd10.js';
import './index-11bc5ac3.js';
import 'moment';

function Price(props) {
  var value = props.value,
    currency = props.currency,
    originalPrice = props.originalPrice,
    discount = props.discount,
    fractionDigits = props.fractionDigits,
    styled = props.styled,
    topPriceReference = props.topPriceReference,
    bottomPriceReference = props.bottomPriceReference,
    currencyDisplay = props.currencyDisplay,
    className = props.className,
    language = props.language;
  var showDiscount = originalPrice != null && originalPrice !== 0 && originalPrice !== value;
  var showDiscountPercent = discount != null && discount !== 0;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "bf-price-main-wrapper ".concat(className)
  }, topPriceReference ? /*#__PURE__*/React__default.createElement("div", {
    className: "bf-price-reference"
  }, topPriceReference) : null, showDiscount ? /*#__PURE__*/React__default.createElement("div", {
    className: "bf-price-discount-wrapper"
  }, /*#__PURE__*/React__default.createElement(FormattedNumber, {
    currency: currency,
    currencyDisplay: currencyDisplay,
    value: originalPrice,
    fractionDigits: fractionDigits,
    className: "bf-price-discount-original-price",
    language: language
  }), showDiscountPercent ? /*#__PURE__*/React__default.createElement(Label, {
    className: "bf-price-discount",
    color: "red",
    size: "small",
    inverted: true,
    content: /*#__PURE__*/React__default.createElement(React__default.Fragment, null, '- ', /*#__PURE__*/React__default.createElement(FormattedNumber, {
      percent: true,
      value: discount,
      language: language
    }))
  }) : null) : null, /*#__PURE__*/React__default.createElement("div", {
    className: "bf-price-wrapper"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "bf-price"
  }, /*#__PURE__*/React__default.createElement(Title, {
    size: "large",
    content: /*#__PURE__*/React__default.createElement(FormattedNumber, {
      currency: currency,
      currencyDisplay: currencyDisplay,
      value: value,
      styled: styled,
      fractionDigits: fractionDigits,
      language: language
    })
  }))), bottomPriceReference ? /*#__PURE__*/React__default.createElement("div", {
    className: "bf-price-reference"
  }, bottomPriceReference) : null);
}
Price.defaultProps = {
  originalPrice: 0,
  discount: 0,
  fractionDigits: 0,
  topPriceReference: '',
  bottomPriceReference: '',
  styled: false,
  className: '',
  language: 'en'
};
Price.propTypes = {
  /**
  Main value
   */
  value: PropTypes.number.isRequired,
  /**
  Number of decimals
   */
  fractionDigits: PropTypes.number,
  /**
  Currency object (code, symbol)
   */
  currency: PropTypes.shape({
    code: PropTypes.string.isRequired,
    symbol: PropTypes.string.isRequired
  }).isRequired,
  /**
  Show currency as symbol or code
   */
  currencyDisplay: PropTypes.string.isRequired,
  /**
  Original price (for discounts)
   */
  originalPrice: PropTypes.number,
  /**
  Discount percent
   */
  discount: PropTypes.number,
  /**
  Label positioned above the price
   */
  topPriceReference: nodeOrStringProp,
  /**
  Label positioned under the price
   */
  bottomPriceReference: nodeOrStringProp,
  /**
  Styled number (currency, integer, decimal)
   */
  styled: PropTypes.bool,
  /**
  Custom className
   */
  className: PropTypes.string,
  /**
  Intl language
   */
  language: PropTypes.string
};

export default Price;
//# sourceMappingURL=Price.js.map
